import script from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=0e2b717b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2b717b"]])

export default __exports__